//      
/* global self */
const createWorker = require('./source/worker');
createWorker(self);
